export default {

    rooms: [
        {
            id: 'room1',
            title: '研究室1(総合研究実験棟7階701室)',
            images: [
            require('@/assets/room/701_1.jpg'),
            require('@/assets/room/701_2.jpg')
            ],
            description: 'それぞれの席にGPU付きのデスクトップPCが設置されています。<br>主な使用OSはLinux（Ubuntu）ですが，研究内容次第ではWindowsを使用することも可能です。<br>手前のテーブルでモニターに映しながら会議することもできます。<br>3Dプリンターもなぜかあります。'
        },
        {
            id: 'room2',
            title: '研究室2(総合研究実験棟6階604室)',
            images: [
            require('@/assets/room/604_1.jpg'),
            require('@/assets/room/604_2.jpg')
            ],
            description: '604室は土足禁止となっています。'
        },
        {
            id: 'room3',
            title: '研究室3(情報センター・院生棟7階704室)',
            images: [
            require('@/assets/room/704_1.jpg'),
            require('@/assets/room/704_2.jpg')
            ],
            description: '現在は留学生が主に使用しています。'
        },
        {
            id: 'server',
            title: 'サーバ室(情報センター・院生棟7階704室奥)',
            images: [
            require('@/assets/room/server_1.jpg'),
            require('@/assets/room/server_2.jpg')
            ],
            description: 'TMAK Lab.には，Linux（Ubuntu）サーバがたくさん設置されています。<br>約50GBのGPUメモリが2個積まれたサーバが2台（研究室内からのみ接続可能）<br>約25GBのGPUメモリが積まれたサーバが2台（研究室外からでもVPN経由で接続可能）<br>を研究をする際に使用することができます。<br>このホームページを動かしているサーバもこの部屋にあります。'
        },
        {
            id: 'zemi',
            title: 'ゼミ室(総合研究実験棟6階605室)',
            images: [
            require('@/assets/room/605_1.jpg'),
            require('@/assets/room/605_2.jpg')
            ],
            description: '大人数で行われるゼミはこの部屋で行われています。<br>作成してきたスライドをプロジェクタでスクリーンに映して全員の前で発表します。'
        },
        {
            id: 'szemi',
            title: '小グループゼミ室(総合研究実験棟7階702室)',
            images: [
            require('@/assets/room/702_1.jpg'),
            require('@/assets/room/702_2.jpg')
            ],
            description: 'A2研究室は感性・対話班，Web・SNS班，の2つの小グループに分かれて研究を行なっています。<br>少人数でリラックスしながらゼミを行うのに適した部屋となっています。'
        },
        {
            id: 'device',
            title: '機器',
            images: [
                {
                    id: 'device1',
                    title: 'Sotaロボット',
                    images: [
                    require('@/assets/device/1.jpg'),
                    ],
                    description: ''
                },
                {
                    id: 'device2',
                    title: '3Dプリンタ',
                    images: [
                    require('@/assets/device/2.jpg'),
                    ],
                    description: ''
                },
                {
                    id: 'device3',
                    title: 'VRゴーグル',
                    images: [
                    require('@/assets/device/3.jpg'),
                    ],
                    description: ''
                },
                {
                    id: 'device4',
                    title: '大型液晶モニタ',
                    images: [
                    require('@/assets/device/4.jpg'),
                    ],
                    description: ''
                },
                {
                    id: 'device5',
                    title: 'Depth Camera',
                    images: [
                    require('@/assets/device/5.jpg'),
                    ],
                    description: ''
                },
                {
                    id: 'device6',
                    title: 'GoPro',
                    images: [
                    require('@/assets/device/6.jpg'),
                    ],
                    description: ''
                },
                {
                    id: 'device7',
                    title: 'LeapMotion',
                    images: [
                    require('@/assets/device/7.jpg'),
                    ],
                    description: ''
                },
                {
                    id: 'device8',
                    title: 'iPad Pro',
                    images: [
                    require('@/assets/device/8.jpg'),
                    ],
                    description: ''
                },
            ],
            description: ''
        }
    ]
}
      
